import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { grey, info, success, error, warning } from '../neutral/colors.js';
export { error, grey, info, success, warning } from '../neutral/colors.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var primary = {
  primary: '#004E76',
  primary900: '#004E76',
  primary800: '#096D97',
  primary700: '#097EAA',
  primary600: '#1790BC',
  primary500: '#1F9DC9',
  primary400: '#3AABCF',
  primary300: '#57B9D5',
  primary200: '#81CDE1',
  primary100: '#B2E1EC',
  primary50: '#E0F3F7'
};
var secondary = {
  secondary: '#004E76',
  secondary900: '#004E76',
  secondary800: '#096D97',
  secondary700: '#097EAA',
  secondary600: '#1790BC',
  secondary500: '#1F9DC9',
  secondary400: '#3AABCF',
  secondary300: '#57B9D5',
  secondary200: '#81CDE1',
  secondary100: '#B2E1EC',
  secondary50: '#E0F3F7'
};
var colors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, grey), primary), secondary), info), success), error), warning);

export { colors, primary, secondary };
//# sourceMappingURL=colors.js.map
